// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seeSimilarButton":"seeSimilarButton_YrBcp"};